module.exports = __webpack_public_path__ + "static/img/award4_a.357a34c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/award4_a.png
// module id = ESAJ
// module chunks = 7